// SearchStory.js
import { connect } from 'react-redux';

import fetchMessageSearch from '../action/fetchMessageSearch.js';
import fetchFeeds from '../action/fetchFeeds.js';
import getOperationData from '../selector/getOperationData.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';
import getListData from '../selector/getListData.js';
import { getSelectedQueryOptionObject } from '../selector/getFeedQueryObject.js';
import getSelectedFeedQueryOptions from '../selector/getSelectedFeedQueryOptions.js';
import SearchStory from '../component/SearchStory.jsx';
import withSearchQuery from '../component/WithSearchQuery.jsx';

const mapStateToProps = (state, { query }) => {
  const { sorts: sortings } = getSelectedQueryOptionObject(
    state,
    '',
    getSelectedFeedQueryOptions(state, 'SEARCH_MESSAGE', undefined)
  );
  const sortingString = sortings.join('&');

  const hasQuery = !!query;
  const defaultStoryCategory = getOperationData(
    state,
    ['recommendStoryCategory'],
    'search'
  );

  const storySelectPath = ['search', 'message', 'story', query];
  const defaultStorySelectPath = ['home', 'messages', defaultStoryCategory];

  const isAuthed = !!getMeData(state, 'id');

  const searchStoryIds = getListData(state, storySelectPath, 'itemIds');
  const defaultStoryIds = getListData(state, defaultStorySelectPath, 'itemIds');

  const isSearchStoryFetched = getNetworkingData(
    state,
    [...storySelectPath, 'firstPage'],
    'isFetched'
  );
  const isDefaultStoryFetched = getNetworkingData(
    state,
    [...defaultStorySelectPath, 1],
    'isFetched'
  );

  return {
    sortingString,
    query,
    defaultStoryCategory,
    isAuthed,
    isStoryFetched: hasQuery ? isSearchStoryFetched : isDefaultStoryFetched,
    hasQuery,
    storyIds: hasQuery ? searchStoryIds : defaultStoryIds,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchFeeds: data => dispatch(fetchFeeds(data)),
    fetchMessageSearch: data => dispatch(fetchMessageSearch(data)),
  };
};

export default withSearchQuery(
  connect(mapStateToProps, mapDispatchToProps)(SearchStory)
);
